import { NavigableModal } from '$components'
import { useNavigate } from 'react-router-dom'
import { EditBusinessDetailsForm, EditBusinessDetailsSchema, Input } from '$features/settings/forms/edit-business-details/index'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { tenantActiveQueryKey, tenantUpdateMutation } from '$api-client/@tanstack/react-query.gen'
import { useTenant } from '$features/auth/hooks/use-tenant'
import { ToastHelper } from '$components'

export function EditBusinessDetailsModal() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const { name, contactEmail, contactPhone, tenantId } = useTenant()

  const { mutate: updateTenant, isPending: isUpdatingTenant } = useMutation({
    ...tenantUpdateMutation(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: tenantActiveQueryKey(),
      })
      ToastHelper.success('Business details updated successfully.')
      handleClose()
    },
    onError: () => ToastHelper.error('Failed to update business details.'),
  })

  const handleClose = () => navigate(-1)

  const handleSubmit = async (values: EditBusinessDetailsSchema) => {
    updateTenant({
      path: {
        id: tenantId!,
      },
      body: {
        business_name: values[Input.BusinessName],
        contact_email: values[Input.ContactEmail],
        contact_phone: values[Input.ContactPhone],
      },
    })
  }

  if (!name || !tenantId) {
    return null
  }

  return (
    <EditBusinessDetailsForm
      onSubmit={handleSubmit}
      onCancel={handleClose}
      isLoading={isUpdatingTenant}
      defaultValues={{
        [Input.BusinessName]: name,
        [Input.ContactEmail]: contactEmail,
        [Input.ContactPhone]: contactPhone,
      }}
    >
      <NavigableModal onClose={handleClose}>
        <NavigableModal.Header>
          <NavigableModal.Heading>
            Edit Business Details
          </NavigableModal.Heading>
        </NavigableModal.Header>

        <NavigableModal.Content>
          <EditBusinessDetailsForm.Content />
        </NavigableModal.Content>

        <NavigableModal.Footer>
          <EditBusinessDetailsForm.Controls />
        </NavigableModal.Footer>
      </NavigableModal>
    </EditBusinessDetailsForm>
  )
}
